import { FC } from 'react';
import { toast } from 'sonner';
import InfoIconSolid from '../icons/InfoIconSolid';
import InfoCircleIconSolid from '../icons/InfoCircleIconSolid';
import AlertIconSolid from '../icons/AlertIconSolid';
import CheckmarkIconSolid from '../icons/CheckmarkIconSolid';
import CancelIcon from '../icons/CancelIcon';

type Props = {
	message: string;
	description?: string;
	variant?: 'success' | 'info' | 'error' | 'warning';
};

const settings = {
	info: {
        border: 'border-popover-1000',
		icon: () => <InfoIconSolid className={'fill-popover-1000'} />,
	},
	success: {
        border: 'border-success-1000',
		icon: () => <CheckmarkIconSolid className={'fill-success-1000'} />,
	},
	error: {
        border: 'border-error-1000',
		icon: () => <InfoCircleIconSolid className={'fill-error-1000'} />,
	},
	warning: {
        border: 'border-warning-1000',
		icon: () => <AlertIconSolid className={'fill-warning-1000'} />,
	},
};

const EToast: FC<Props> = ({ message, description, variant = 'info' }) => {
	return toast.custom((t) => (
		<div className={`w-80 bg-popover-10 border-l-4 ${settings[variant].border} rounded-xl shadow-toast select-none`}>
			<div className={'flex gap-2.5 px-4 py-3.5'}>
				<div>{settings[variant].icon()}</div>
				<div className={'flex grow flex-col gap-0.5'}>
					<h3 className={'text-sm font-medium'}>{message}</h3>
					{description && (
						<p className={'text-sm text-popover-800'}>
							{description}
						</p>
					)}
				</div>
				<button className='h-fit' onClick={() => toast.dismiss(t)}>
					<CancelIcon />
				</button>
			</div>
		</div>
    ),{duration: 2000});
};

export default EToast;
